
import { mapGetters } from 'vuex'
import FilterToggle from './ui/filter-toggle.vue'
import FilterDropdown from './ui/filter-dropdown.vue'
import FilterColor from './filter-color'
import FilterSize from './filter-size'
import FilterCheckbox from './filter-checkbox'
import FilterSortby from './filter-sortby'
import FilterAllFilters from './filter-allfilters'
import FilterReset from './filter-reset'

export default {
  components: {
    FilterToggle,
    FilterDropdown,
    FilterColor,
    FilterSize,
    FilterCheckbox,
    FilterSortby,
    FilterAllFilters,
    FilterReset,
  },
  props: {
    searchResults: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      allFiltersModal: false,
      openedDropdown: null,
      selectedSortingOption: null,
    }
  },
  computed: {
    ...mapGetters({
      vxStoryContent: 'search/getStoryContent',
      vxSearchParams: 'search/getSearchParameters',
    }),
    filterFacets() {
      const tmpSearchResults = this.searchResults
      return tmpSearchResults.facets.sort((a, b) => {
        if (a.label < b.label) return -1
        if (a.label > b.label) return 1
        return 0
      })
    },
    basicFilterFacets() {
      const sortOrder = [
        'ss_final_price',
        'ss_normalize_color',
        'variant_size',
        'tags_en_facet_natural_fibers_filter',
        'ss_on_sale',
      ]

      // return only facets in the sort order by sort order
      return this.filterFacets
        .filter((facet) => sortOrder.includes(facet.field))
        .sort((a, b) => {
          return sortOrder.indexOf(a.field) - sortOrder.indexOf(b.field)
        })
    },
    activeFilterFacets() {
      return this.vxSearchParams.filters
    },
    sizeFacets() {
      const sf = this.filterFacets.find(
        (facet) => facet.field === 'variant_size'
      ).values

      const osFilterIndex = sf.findIndex((facet) => facet.value === 'O/S')

      if (osFilterIndex !== -1) {
        const osFilter = sf.splice(osFilterIndex, 1)[0]
        sf.push(osFilter)
      }
      return sf
    },
  },
  methods: {
    getActiveFiltersCount(facet) {
      return facet.values.filter((item) => item.active).length
    },
    getAllFiltersCount() {
      return this.filterFacets.reduce((acc, facet) => {
        return acc + this.getActiveFiltersCount(facet)
      }, 0)
    },
    openFiltersModal() {
      this.allFiltersModal = true
    },
    closeFiltersModal() {
      this.allFiltersModal = false
    },
    setOpenedDropdown(filterField) {
      this.openedDropdown = filterField
    },
    setSortby(sortingOption) {
      this.selectedSortingOption = sortingOption
    },
  },
}
